export { default } from "./LessonOverviewSpeechBubble";
